import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { AdvancedButton } from "components/Buttons";
import { ICON_TYPE } from "components/Icon";
import { OrganizationBillingForm } from "components/Organizations";
import { useAuth } from "hooks";
import Tooltip from "components/Tooltip";

/**
 * BillingAdvanceOption
 *
 * @param {Object} data The billing data for the organization.
 */
const BillingAdvanceOption = ({ data, ...props }) => {
  const [showForm, setShowForm] = useState(false);
  const { isAdmin } = useAuth();
  const { isEditable } = data || {};

  if (!isAdmin) return null;

  const editOption = [
    {
      label: isEditable ? (
        <FormattedMessage id={`Organization.BillingAdvanceOption.EditBilling`} />
      ) : (
        <Tooltip tooltipId={"Organization.BillingAdvanceOption.EditBilling.Tooltip"}>
          <FormattedMessage id={`Organization.BillingAdvanceOption.EditBilling`} />
        </Tooltip>
      ),
      icon: ICON_TYPE.edit,
      onClick: () => setShowForm(true),
      disabled: !isEditable,
    },
  ];

  return (
    <>
      <AdvancedButton options={editOption} />
      <OrganizationBillingForm
        show={showForm}
        onClose={() => setShowForm(false)}
        isEditing={true}
        data={data}
        {...props}
      />
    </>
  );
};

BillingAdvanceOption.propTypes = {
  data: PropTypes.object,
};

export default BillingAdvanceOption;
